import styled from 'styled-components';

// Components
import ModalContainer from '../../containers/ModalContainer';
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

/**
 * Confirmación destructiva, con la estructura canónica de la familia
 * (ForceCloseRouteModal / DeleteExternalCompanyModal): overlay de Loader
 * absoluto + contenido atenuado, icono de alerta a su tamaño natural y
 * centrado por el propio flex de la columna, bloque de texto agrupado y fila
 * de botones centrada.
 */
export const ModalContainerStyled = styled(ModalContainer)`
  position: relative;
`;

export const ContainerLoader = styled.div`
  position: absolute;
  top: 40%;
  left: 45%;
  z-index: 1;
`;

export const Container = styled.div<{ isLoading?: boolean }>`
  opacity: ${({ isLoading }) => (isLoading ? 0.6 : 1)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  width: 100%;
  /* Sin padding horizontal propio: el ModalContainer ya aplica el suyo. */
  padding: 0.5rem 0 1rem;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  /* Medida de lectura cómoda: ni línea kilométrica ni palabra por renglón. */
  max-width: 42rem;
`;

export const Text = styled(Typography)`
  text-align: center;
`;

export const Title = styled(Text)`
  font-size: 2.4rem;
`;

/**
 * El nombre del fichero que se va a borrar: destacado, sin caja gris. Va con
 * `break-word` porque los nombres de foto son largos y sin espacios
 * (`Tr_0000357_0002_02_20260810_2306_photo_01`).
 */
export const PhotoName = styled(Text)`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.garnet};
  word-break: break-word;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.m};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet *
    theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const ActionButton = styled(MainButton)`
  min-width: 13.4rem;
  justify-content: center;
`;
